module.exports = __webpack_public_path__ + "static/media/aa2000.e23b3039.svg";